import React, { useState } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";
import { TaskLog } from "../types/TaskLog";

interface Props {
  initialData?: TaskLog | null;
  onSave: (data: TaskLog) => void;
}

const TaskLogsForm: React.FC<Props> = ({ initialData, onSave }) => {
  const [formData, setFormData] = useState<TaskLog>({
    id: initialData?.id ?? 0,
    taskId: initialData?.taskId ?? 0,
    eventType: initialData?.eventType ?? "",
    message: initialData?.message ?? "",
    createBy: initialData?.createBy ?? "",
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Row className="mb-3">
        <Col md={6}>
          <Form.Group controlId="taskId">
            <Form.Label>Task ID</Form.Label>
            <Form.Control
              type="number"
              name="taskId"
              value={formData.taskId}
              onChange={handleChange}
              required
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group controlId="eventType">
            <Form.Label>Event Type</Form.Label>
            <Form.Control
              type="text"
              name="eventType"
              value={formData.eventType}
              onChange={handleChange}
              required
            />
          </Form.Group>
        </Col>
      </Row>

      <Form.Group controlId="message" className="mb-3">
        <Form.Label>Message</Form.Label>
        <Form.Control
          as="textarea"
          rows={3}
          name="message"
          value={formData.message}
          onChange={handleChange}
          required
        />
      </Form.Group>

      <Button type="submit" className="w-100" variant="primary">
        {initialData ? "Update Task Log" : "Add Task Log"}
      </Button>
    </Form>
  );
};

export default TaskLogsForm;
